import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { DeleteCourseModal } from "../DeleteCourseModal";
import { useState } from "react";
import { environment } from "configs/environment";

export function CourseActionCell(props) {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  return (
    <SoftBox display="flex" alignItems="center">
      <DeleteCourseModal open={openDeleteModal} course={props.course} onClose={() => setOpenDeleteModal(false)} />
      {/* <SoftTypography component="a" href={environment.WEB_CLIENT.HOST + environment.WEB_CLIENT.URIS.COURSES + "/" + props.course.id} target="_blank" variant="body1" color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }}>
        <Tooltip title="Preview Course" placement="top">
          <Icon>visibility</Icon>
        </Tooltip>
      </SoftTypography> */}
      <SoftBox mx={2} display="flex" alignItems="center">
        <SoftTypography component={Link} to={"/admin/courses/all/edit/" + props.course.id} variant="body1" color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }}>
          <Tooltip title="Edit Course" placement="top">
            <Icon>edit</Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
      <SoftTypography variant="body1" color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }} onClick={() => setOpenDeleteModal(true)}>
        <Tooltip title="Delete Course" placement="left">
          <Icon>delete</Icon>
        </Tooltip>
      </SoftTypography>
    </SoftBox>
  );
}

CourseActionCell.propTypes = {
  course: PropTypes.any.isRequired,
};